import React, { useState } from 'react';
import '../../../entrydoor.css';

const HorizontalGrills = ({ value, onChange, id = 'HorizontalGrills', label = 'Horizontal:', disabled = false }) => {
    const [selectedHorizontalGrills, setSelectedHorizontalGrills] = useState(value || "0");
     const [HorizontalGrillsError, setHorizontalGrillsError] = useState("");

    const handleHorizontalGrillsChange = (e) => {
        //setSelectedHorizontalGrills(e.target.value);
        validateHorizontalGrills(e.target.value);
        onChange(e.target.value);
    };
    const validateHorizontalGrills = (value) => {
        const numericValue = value.replace(/\D/g, ""); // Allow only numbers
        setSelectedHorizontalGrills(numericValue);
      
        if (numericValue && (numericValue < 0 || numericValue > 10)) {
            setHorizontalGrillsError('must be between 0" and 10"');
        } else {
            setHorizontalGrillsError("");
        }
    };
    return (
        <div className="a-container">
            <label style={{ display1: "none" }} disabled={disabled} htmlFor={id}>{label}</label>
            <input style={{ display1: "none" }}
                disabled={disabled}
                id={id}
                value={selectedHorizontalGrills}
                onChange={handleHorizontalGrillsChange}
            >
            </input>
            {HorizontalGrillsError && <p className="error">{HorizontalGrillsError}</p>}
        </div>
    );
};

export default HorizontalGrills;
